import { render, staticRenderFns } from "./S40.vue?vue&type=template&id=7cad8901&scoped=true"
import script from "./S40.vue?vue&type=script&lang=js"
export * from "./S40.vue?vue&type=script&lang=js"
import style0 from "./S40.vue?vue&type=style&index=0&id=7cad8901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cad8901",
  null
  
)

export default component.exports